// extracted by mini-css-extract-plugin
export default {"header":"BannerList_header__9CXhK","imageWrapper":"BannerList_imageWrapper__Ygild","image":"BannerList_image__VXYVS","row":"BannerList_row__AqWfc"};